import type {AppThunk} from '../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../../routes/loadEndpoint'
import {restApi} from '../../../../../services/rest'
import type {ProjectId} from '../../../../../types'
import {getTestsLocator as getTestTreeLocator} from '../../../../packages/Tests/TestsTree/TestsTree.utils'

import {getProjectInvestigationsTabTreeArg} from './ProjectInvestigationsTabTree.utils'

export const preloadProjectInvestigationsTabTree =
  (projectId: ProjectId): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const locator = getTestTreeLocator({projectId})
    return [
      dispatch(
        loadEndpoint(
          restApi.endpoints.getTestOccurrenceTree,
          getProjectInvestigationsTabTreeArg(locator),
        ),
      ),
    ]
  }
